"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = compare;
const Arrays_1 = require("../Utility/Arrays");
const Objects_1 = require("../Utility/Objects");
function compare(leftValue, rightValue) {
    if (typeof leftValue !== typeof rightValue) {
        return false;
    }
    if (leftValue === rightValue) {
        return true;
    }
    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
        return Arrays_1.default.deepEquals(leftValue, rightValue);
    }
    if (Objects_1.default.isJSONObject(leftValue) && Objects_1.default.isJSONObject(rightValue)) {
        return Objects_1.default.deepEquals(leftValue, rightValue);
    }
    return false;
}
//# sourceMappingURL=Compare.js.map